export default { sha: '4e6288c89114ff49ae7c86e049117112b575b7f5', buildNumber: 'undefined' }
